import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface DateRange {
  from?: Date;
  to?: Date;
}

export interface DateRangePickerProps {
  value: DateRange;
  onValueChange: (range: DateRange) => void;
  className?: string;
}

function format(d?: Date) {
  if (!d) return "—";
  return d.toLocaleDateString("nl-NL", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function DateRangePicker({ value, onValueChange, className }: DateRangePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="default" className={cn("h-8 gap-2", className)}>
          <CalendarIcon size={14} />
          <span className="font-mono text-[12px]">
            {format(value.from)} – {format(value.to)}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Calendar
          mode="range"
          selected={value as { from: Date; to?: Date }}
          onSelect={(range) => onValueChange(range ?? {})}
          numberOfMonths={2}
        />
      </PopoverContent>
    </Popover>
  );
}
